import React from 'react';
import { Box, Paper, Stack, Typography, Button } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

type AccessDeniedProps = {
  title?: string;
  message?: string;
  minHeight?: number | string;
  actionText?: string;
  onActionClick?: () => void;
};

const AccessDenied: React.FC<AccessDeniedProps> = ({
  title = 'Acceso restringido',
  message = 'No tienes permisos para ver esta visualización.',
  minHeight = '60vh',
  actionText,
  onActionClick,
}) => {
  return (
    <Box
      sx={{
        minHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 420,
          p: 3,
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
          textAlign: 'center',
        }}
      >
        <Stack spacing={1.25} alignItems="center">
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              bgcolor: 'action.hover',
            }}
          >
            <LockOutlinedIcon />
          </Box>

          <Typography variant="h6" fontWeight={700}>
            {title}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {message}
          </Typography>

          {actionText && onActionClick && (
            <Button variant="contained" onClick={onActionClick} sx={{ mt: 1 }}>
              {actionText}
            </Button>
          )}
        </Stack>
      </Paper>
    </Box>
  );
};

export default AccessDenied;
